import React from "react";
import image from "../images/motion-background.jpg";

const imageAltText = "purple and blue abstract background";

const description =
  "I'm a CSE student studying at VIT, Bhopal. I enjoy creating unique and simplistic user interfaces in creative ways.";

const skillsList = [
  "Full stack development",
  "Web design",
  "User experience",
  "Graphic design",
  "Open source",
];

const detailOrQuote =
  "Hi, my name is Gyanendra, and I'm a passionate coder and developer who is driven by results. I possess a unique combination of technical expertise and creative problem-solving skills. Currently, I am pursuing my bachelor's degree in Computer Science and Engineering from Vellore Institute of Technology - Bhopal. I have participated in HacktoberFest and have also been a global nominee in NASA Space Challenges. Moreover, I am a certified MERN Stack Developer.";

const About = () => {
  return (
    <section className="padding" id="about">
      <img className="background" src={image} alt={imageAltText} />
      <div
        style={{
          backgroundColor: "white",
          width: "50%",
          padding: "4rem",
          margin: "3rem auto",
          textAlign: "center",
        }}
      >
        <h2>About Myself</h2>
        <p className="large">{description}</p>
        <hr />
        <ul
          style={{
            textAlign: "left",
            columns: 2,
            fontSize: "1.25rem",
            margin: "2rem 3rem",
            gap: "3rem",
          }}
        >
          {skillsList.map((skill) => (
            <li key={skill}>{skill}</li>
          ))}
        </ul>
        <hr />
        <p style={{ padding: "1rem 3rem 0" }}>{detailOrQuote}</p>
      </div>
    </section>
  );
};

export default About;
